module.exports = __webpack_public_path__ + "img/instagram.27eb0e55.svg";